import React, { Fragment, useEffect, useState, useRef } from 'react';
import Carousel from 'react-grid-carousel'
import { v4 as uuid } from 'uuid'
import { AutoComplete } from "primereact/autocomplete";

import { NumericFormat } from 'react-number-format';

// Atom
// import Button from 'Components/Atoms/Button'


import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';

//Modal
import Modal, { ModalSize } from 'Components/Molecules/Modal'
import MChannelsPartModal from 'Components/Molecules/Modal/Part/MChannels'
import MSolicitarPartModal from 'Components/Molecules/Modal/Part/MSolicitar'
import MSolicitarSalesPartModal from 'Components/Molecules/Modal/Part/MSolicitarSales'

import { CategoriesService, ChannelsService, CoverageTypeService, PaqueteService, OpcionFiltrosService, PlanService } from 'actions/HttpCalls'
import { HttpClient } from 'actions/HttpClient'


const httpClient = new HttpClient();
const categoriesService = new CategoriesService(httpClient);
const channelsService = new ChannelsService(httpClient);
const opcionFiltrosService = new OpcionFiltrosService(httpClient);
// eslint-disable-next-line
const coverageTypeService = new CoverageTypeService(httpClient);
// eslint-disable-next-line
const paqueteService = new PaqueteService(httpClient);
const planService = new PlanService(httpClient);

function ChannelGuide(props) {

	const modalChannelsRef = useRef()
	const modalRequestRef = useRef()
	const modalSalesRef = useRef()

	const openModalChannels = () => modalChannelsRef.current.open()
	const closeModalChannels = () => modalChannelsRef.current.close()
	const openModalRequest = () => modalRequestRef.current.open()
	const openModalSales = () => modalSalesRef.current.open()
	const closeModalSales = () => modalSalesRef.current.close()

	const onClickChangeChannels = () => {
		openModalChannels()
	}
	const onClickChangeChannelsClose = () => {
		closeModalChannels()
	}

	const onClickRequest = () => {
		console.log('Contratar')
		openModalRequest()
	}

	// const channels = ["amc-hd", "axn", "cine-canal", "cine-latino", "cinemax", "claro-cinema", "dhe", "film-arts", "fxm", "golden", "hbo", "paramount", "space-hd", "tcm", "universal", "amc-hd", "axn", "cine-canal", "cine-latino", "cinemax", "claro-cinema", "dhe", "film-arts", "fxm", "golden"];
	const [dataCategorias, setDataCategorias] = useState([])
	const [dataChannelsBk, setDataChannelsBk] = useState([])
	const [dataChannels, setDataChannels] = useState([])
	const [dataCPlans, setDataCPlans] = useState([])
	const [planes, setPlanes] = useState([])
   
	const [dataOpcionFiltros, setDataOpcionFiltros] = useState([])
	const [dataOpcionFiltrosBk, setDataOpcionFiltrosBk] = useState([])
	const [idOpFiltro, setIdOpFiltro] = useState("")

	const [dataListChannels, setDataListChannels] = useState([])
	const [idTypeFilter, setIdTypeFilter] = useState("")
	const [idCategory, setIdCategory] = useState("")
	const [channelName, setChannelName] = useState("")
	const [channelSearchInput, setChannelSearchInput] = useState('')
	const [dataChannelNamesBk, setDataChannelNamesBk] = useState([])
	const [dataChannelNames, setDataChannelNames] = useState([])
	const [dataChannelAutoComplet, setDataChannelAutoComplet] = useState([])
	const [inputDisabled, setInputDisabled] = useState(true)

	const [dataCoverageTypes, setDataCoverageTypes] = useState([])
	const [fcTipoCobertura, setFcTipoCobertura] = useState("")
	const [dataPaquetes, setDataPaquetes] = useState([])
	const [dataPaquetesBK, setDataPaquetesBk] = useState([])
	const [fiPaquete, setFiPaquete] = useState("")

	const [title, setTitle] = useState("")
	const [fc_DESCRIPCION, setFc_DESCRIPCION] = useState("")
	const [fi_PRECIO_PLAN, setFi_PRECIO_PLAN] = useState("")
	const [fc_ETIQUETA_PERIODO, setfc_ETIQUETA_PERIODO] = useState("")
	const [lstPlanContratacionxPlan, setlstPlanContratacionxPlan] = useState([])
	const [fi_SERVICIO, setFi_SERVICIO] = useState("")

	const getValuesDefault = async () => {
		const channels = await channelsService.getChannelsItems()
		setDataChannels(channels)
		setDataChannelsBk(channels)
		// const todos = await todoService.getTodoItems();
		const categories = await categoriesService.getCategoriesItems()
		setDataCategorias(categories)

		const opcionFiltros = await opcionFiltrosService.getOptionFiltroItems()
		setDataOpcionFiltrosBk(opcionFiltros)

		const coverageTypes = []//await coverageTypeService.getCoverageTypeItems()
		setDataCoverageTypes(coverageTypes)

		const paquetes = []//await paqueteService.getPaqueteItems()
		// setDataPaquetes(paquetes)
		setDataPaquetesBk(paquetes)

		const cplanes = await planService.getPlanItems()
		setDataCPlans(cplanes)

		// console.log("todoService", todos)
		if (channels?.length) {
			setInputDisabled(false)
			setArrayListChanneNames(channels, true)
		}
		console.log("channels", channels)
		console.log("categories", categories)
		console.log("opcionFiltros", opcionFiltros)
		console.log("cplanes", cplanes)
		// console.log("coverageTypes", coverageTypes)
		// console.log("paquetes", paquetes)
	}

	useEffect(() => {
		getValuesDefault();
		// eslint-disable-next-line
	}, [])

	async function setArrayListChanneNames(namesChannel, isFromDefault = null, idCat = null) {
		let channels = idCat ? dataChannelsBk.filter(c => c.fi_categoria === idCat) : namesChannel
		let newArray = channels.reduce(function (a, c) {
			if (a.indexOf(c.fc_nombre) === -1) {
				a.push(c.fc_nombre)
			}
			return a

		}, [])

		newArray.length ? setDataChannelNames(newArray.sort()) : setDataChannelNames([]);
		isFromDefault === true ? setDataChannelNamesBk(newArray.sort()) : isFromDefault = false
		idCat ? setDataListChannels(newArray?.sort()) : idCat = false;
	}

	const getChannelsByCategoryId = async (id) => {
		let idCat = parseInt(id.split("_")[0])
		setIdCategory(id)
		setChannelName(id.split("_")[1])
		//setIdPlanFilter("")
		setIdOpFiltro("")

		let filtrosIncludes = []
		const listCat = dataCategorias.filter(c => c.fi_categoria === idCat)
		listCat.forEach(((cat, index) => {
			cat.lstOpcionFiltros.forEach((f, i) => {
				if (f?.fi_opcion_filtro) {
					filtrosIncludes.push(f.fi_opcion_filtro)
				}
			})
		}))
		if (idCat === 8 || idCat === 9) {

			const listChannels = idCat === 9 ? dataChannelsBk.filter(c => (c.fi_categoria === idCat || c.fi_categoria === 10)) : dataChannelsBk.filter(c => c.fi_categoria === idCat)
			console.log("getChannelsByCategoryId listCat filter by fi_categoria Premium", listChannels)
			setDataChannels(listChannels)
			setDataOpcionFiltros([])
		} else {
			const listChannels = []
			let listChannels2 = []
			dataChannelsBk.forEach((c, index) => {
				let arrayFilt = c.lstOpcionFiltros.filter(f => filtrosIncludes.includes(f.fi_opcion_filtro))
				return (arrayFilt.length ? listChannels.push(c) : null)
			});
			listChannels2 = listChannels.filter(c => c.fi_categoria === idCat)
			console.log("getChannelsByCategoryId listCat filter by fi_categoria ", filtrosIncludes, listChannels2)
			setDataChannels(listChannels2)

			const listFiltros = dataOpcionFiltrosBk.filter(opf => filtrosIncludes.includes(opf.fi_opcion_filtro));
			setDataOpcionFiltros(listFiltros)
			console.log("getChannelsByCategoryId listFiltros filter by fi_categoria ", listFiltros)
		}

		// const listChannels = dataChannelsBk.filter(c => c.fi_categoria === idCat);
		// console.log("getChannelsByCategoryId listCat filter by fi_categoria ", filtrosIncludes, listChannels)
		// setDataChannels(listChannels)

		// const listChannels = dataChannelsBk.filter(c => c.fi_categoria === idCat);
		// setDataChannels(listChannels)
		// setArrayListChanneNames(dataChannelsBk, false, idCat)
		// console.log("listChannels", listChannels, idCat)
	}
	const getChannelsByIdFiltro = async (id) => {
		let txtName = id.split("_")[1]
		let fiOpFiltro = parseInt(id.split("_")[0])

		setIdOpFiltro(id)
		setChannelName(txtName)

		const listChannels = []
		
		dataChannelsBk.forEach((c, index) => {
			let arrayFilt = c.lstOpcionFiltros.filter(f => f.fi_opcion_filtro === fiOpFiltro)
			return (arrayFilt.length ? listChannels.push(c) : null)
		});

		setDataChannels(listChannels)

		let listPlanes = []
		dataCPlans.forEach((pl, index) => {
			let arrayFilt = pl.lstPlanFiltros.filter(f => f.fi_opcion_filtro === fiOpFiltro)
			return (arrayFilt.length ? listPlanes.push(pl) : null)
		});

		setPlanes(listPlanes)

		console.log("getChannelsByIdFiltro ", fiOpFiltro, listChannels, listPlanes.length, listPlanes)
	}
	const getShowChannesBy = async (id) => {
		setIdTypeFilter(id);
		setDataChannels(dataChannelsBk)

		setChannelName("")
		setFcTipoCobertura("")
		setFiPaquete("")
		setIdCategory("")
		setIdOpFiltro("")
		setDataOpcionFiltros([])

		if (id === "2") {
			let catIncludes = [];
			dataCategorias.forEach((ca, index) => {
				catIncludes.push(ca.fi_categoria)
			})
			const listChannels = dataChannelsBk.filter(c => catIncludes.includes(c.fi_categoria));
			setDataChannels(listChannels)
			setArrayListChanneNames(listChannels, false)
		}
	}
	const getTecnologyByCoverageType = async (coverageName) => {
		setFcTipoCobertura(coverageName)
		setFiPaquete("")
		const paquetesFiltered = dataPaquetesBK.filter(p => p.fc_tipo_cobertura === coverageName)
		paquetesFiltered.length ? setDataPaquetes(paquetesFiltered) : setDataPaquetes([])
		// console.log("coverageName", coverageName, dataPaquetesBK, paquetesFiltered)
	}

	const getChannelsByName = async (name, inputSearh = false) => {
		setIdOpFiltro('')
		setChannelName(name)
		const listChannels = inputSearh ? dataChannelsBk.filter(c => (c.fc_nombre.toLowerCase().indexOf(name.toLowerCase()) >= 0 || ("" + c.fi_no_canal).indexOf(name) >= 0)) : dataChannelsBk.filter(c => (c.fc_nombre.indexOf(name) && c.fi_categoria === parseInt(idCategory.split("_")[0])));
		setDataChannels(listChannels)
	}

	const getChannelsByPaquete = async (idPaquete) => {
		let idPaq = parseInt(idPaquete)
		setFiPaquete(idPaq)
		// const listChannels = dataChannelsBk.filter(c => (c.fc_nombre === name && c.fi_categoria === idCategory));
		// setDataChannels(listChannels)
	}

	const searchChannelsByName = (event) => {
		// Timeout to emulate a network connection
		setTimeout(() => {
			let _filteredNameChannel;

			if (!event.query.trim().length) {
				_filteredNameChannel = [...dataChannelNames];
			}
			else {
				_filteredNameChannel = dataChannelNames.filter((nameChannel) => {
					return nameChannel.toLowerCase().startsWith(event.query.toLowerCase());
				});
			}

			setDataChannelAutoComplet(_filteredNameChannel);
		}, 10);
	}

	function clearFilters(e) {
		setIdTypeFilter("")
		setIdCategory("")
		setChannelName("")
		setChannelSearchInput("")
		setDataChannels(dataChannelsBk)
		setDataChannelNames(dataChannelNamesBk)
		setFcTipoCobertura("")
		setDataPaquetes([])
		setIdOpFiltro("")
		setDataOpcionFiltros([])
		// setDataCategorias([])
		// setDataListChannels([])
	}

	function setValuesModalSolicitar(plan) {
		setTitle(plan.fc_texto_caja)
		setFc_DESCRIPCION(plan.fc_descripcion)
		setFi_PRECIO_PLAN(plan.fi_precio_plan)
		setfc_ETIQUETA_PERIODO(plan.fc_etiqueta_periodo)
		setlstPlanContratacionxPlan(plan.lstPlanContratacionxPlan)
		setFi_SERVICIO(plan.fi_SERVICIO)
		onClickRequest()
	}

	function getTxtCaracteristicas(caracteristicas) {
		var text = ""
		for (let i = 0; i < caracteristicas.length; i++) {
			var c = caracteristicas[i];
			text = text + c.fc_TITULO + " " + c.fc_VALOR + ", "
		}
		text = text.slice(0, -2) + '';
		return text
	}

	const _renderChannelBox = items => (
		items && items.length > 0
			? items
				.map((item, index) =>
					<div className="chGuideChannelBox small" key={item.fi_canal}>
						<div className="chGuideChannelBoxImg">
							{
								item.fc_imagen &&
								<picture>
									<source data-srcset={`${item.fc_imagen.split(".")[0]}.webp`} type="image/webp" />
									<source data-srcset={`${item.fc_imagen}`} type={`image/` + item.fc_imagen.split(".")[1]} />
									<img className="lazyload" data-src={`${item.fc_imagen}`} alt="" />
								</picture>
							}
						</div>
						<div className="chGuideChannelBoxText">
							<p>{item.fc_nombre}</p>
							<span>{item.fc_descripcion} {item.fi_no_canal ? "#" + item.fi_no_canal : ""}</span>
						</div>
					</div>
				)
			: 'No hay datos'
	)

	const optionsCategories = dataCategorias?.length ? dataCategorias.map((item, index) => (
		<option key={uuid()} value={item.fi_categoria + "_" + item.fc_descripcion}>{item.fc_descripcion}</option>
	)) : null

	// eslint-disable-next-line
	const optionsChannelNames = dataListChannels?.length ? dataListChannels.map((item, index) => (
		<option key={uuid()} value={item}>{item}</option>
	)) : null

	const optionsFiltros = dataOpcionFiltros?.length ? dataOpcionFiltros.map((item, index) => (
		<option key={uuid()} value={item.fi_opcion_filtro + "_" + item.fc_descripcion}>{item.fc_descripcion}</option>
	)) : null

	const optionsCoverageTypes = dataCoverageTypes?.length ? dataCoverageTypes.map((item, index) => (
		<option key={uuid()} value={item.fc_tipo_cobertura}>{item.fc_descripcion}</option>
	)) : null

	const optionsPaquetes = dataPaquetes?.length ? dataPaquetes.map((item, index) => (
		<option key={uuid()} value={item.fi_paquete}>{item.fc_descripcion}</option>
	)) : null

	const textTituloSeccion = localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : ""
	const textTituloFilter = localStorage.getItem('referencia_producto') ? localStorage.getItem('referencia_producto') : null
	const symbolPrice = "$";
	// console.log("channels", dataChannels)
	return (
		<Fragment>
			<section className="chGuideSearch">
				<div className="container">
					<div className="chGuideSearchBox">
						<div className="chGuideSearchField">
							<p className="h5">Buscar por Canal</p>
							<fieldset>
								<label>Escribe el nombre del Canal</label>
								<div className="searchComp">
									{/* <input type="text" /> */}
									<AutoComplete
										placeholder="..."
										value={channelSearchInput}
										suggestions={dataChannelAutoComplet}
										completeMethod={searchChannelsByName}
										onChange={(e) => { setChannelSearchInput(e.target.value); }}
										// className="spanSelect"
										style={{ width: "100%" }}
										disabled={inputDisabled}
										type="text"
									/>
									<div className="searchCompBtns">
										<button className="search">
											<i className="ico-search" onClick={(e) => { getChannelsByName(channelSearchInput, true); }}></i>
										</button>
										<button className="close" onClick={(e) => { clearFilters() }}>
											<i className="ico-x"></i>
										</button>
									</div>
								</div>
							</fieldset>
						</div>
						<div className="chGuideSearchFilter">
							<h2 className="h5">{textTituloFilter ? textTituloFilter : ""}</h2>
							<div className="chGSFcolset">
								<fieldset>
									<label>Mostrar Canales por:</label>
									<span className="select">
										<select value={idTypeFilter} onChange={(e) => getShowChannesBy(e.target.value)}>
											<option value="">Todos</option>
											{/* <option value={1}>Tecnolog&iacute;a</option> */}
											<option value={2}>Categor&iacute;a</option>
										</select>
									</span>
								</fieldset>
								{
									idTypeFilter === "1" &&
									<>
										<fieldset>
											<label>Selecciona una opción:</label>
											<span className="select">
												<select value={fcTipoCobertura} onChange={(selected) => { getTecnologyByCoverageType(selected.target.value); }}>
													<option value="" disabled>...</option>
													{optionsCoverageTypes}
												</select>
											</span>
										</fieldset>
										<fieldset>
											<label>Selecciona una Tecnolog&iacute;a:</label>
											<span className="select">
												<select value={fiPaquete} onChange={(selected) => { getChannelsByPaquete(selected.target.value) }}>
													<option value="" disabled>...</option>
													{optionsPaquetes}
												</select>
											</span>
										</fieldset>
									</>
								}
								{
									idTypeFilter === "2" &&
									<>
										{
											dataCategorias.length > 0 &&
											<fieldset>
												<label>Selecciona una opci&oacute;n:</label>
												<span className="select">
													<select value={idCategory} onChange={(selected) => { getChannelsByCategoryId(selected.target.value) }}>
														<option value="" disabled>...</option>
														{optionsCategories}
													</select>
												</span>
											</fieldset>
										}
										{
											dataOpcionFiltros.length > 0 && idTypeFilter !== "" && channelName !== "" &&
											<fieldset>
												<label>Selecciona una opci&oacute;n:</label>
												<span className="select">
													<select value={idOpFiltro} onChange={(selected) => { getChannelsByIdFiltro(selected.target.value) }}>
														<option value="" disabled>...</option>
														{optionsFiltros}
													</select>
												</span>
											</fieldset>
										}
									</>
								}
								<fieldset>
									<button className="textLink" onClick={(e) => { clearFilters() }}>Limpiar Filtros</button>
								</fieldset>
							</div>
						</div>
					</div>
				</div>
			</section>
			{
				idOpFiltro === "" &&
				<section className="chGuideChannels">
					<div className="container">
						{
							channelName &&
							<h2 className="h4">{!dataChannels.length ? 'No se encuentran resultados para ' : textTituloSeccion} <strong>{channelName}</strong></h2>
						}
						<div className="chGuideChannelsSlider">
							{
								dataChannels.length > 0 &&
								<Carousel
									cols={5}
									rows={4}
									gap={20}
									showDots={true}
									dotColorActive={"#3C3C3C"}
									dotColorInactive={"#BBBBBB"}
									responsiveLayout={[
										{
											breakpoint: 1280,
											cols: 4
										},
										{
											breakpoint: 960,
											cols: 3
										},
										{
											breakpoint: 760,
											cols: 2
										},
										{
											breakpoint: 480,
											cols: 1
										},
									]}
									mobileBreakpoint={105}
								>
									{dataChannels.length ? dataChannels.map(channel => (
										<Carousel.Item key={uuid()}>
											<div className="chGuideChannelBox" data-idcanal={channel.fi_canal}>
												<div className="chGuideChannelBoxImg">
													{
														channel.fc_imagen &&
														<picture>
															<source data-srcset={`${channel.fc_imagen.split(".")[0]}.webp`} type="image/webp" />
															<source data-srcset={`${channel.fc_imagen}`} type={`image/` + channel.fc_imagen.split(".")[1]} />
															<img className="lazyload" data-src={`${channel.fc_imagen}`} alt="" />
														</picture>
													}
												</div>
												<div className="chGuideChannelBoxText">
													<p>{channel.fc_nombre}</p>
													<span>{channel.fc_descripcion} {channel.fi_no_canal ? "#" + channel.fi_no_canal : ""}</span>
													{
														channel.fc_texto_detalle &&
														<a href={channel.fc_url_detalle ? channel.fc_url_detalle : "#!"} target={channel.fc_target_detalle ? channel.fc_target_detalle : "_self"} className="textLink">{channel.fc_texto_detalle}</a>
													}
												</div>
											</div>
										</Carousel.Item>
									)) : null}
								</Carousel>
							}
						</div>
					</div>
				</section>
			}
			{
				idOpFiltro !== "" && planes?.length > 0 &&
				<section className="chGuideChannels">
					<div className="container">
						<h2 className="h4">Planes en donde encuentras este canal: <strong>{channelName ? channelName : ""}</strong></h2>
						<div className="chGuideChannelsPlans">
							<Carousel
								cols={1}
								rows={3}
								gap={20}
								showDots={true}
								dotColorActive={"#3C3C3C"}
								dotColorInactive={"#BBBBBB"}
								responsiveLayout={[
									{
										breakpoint: 1280,
										cols: 1
									},
									{
										breakpoint: 960,
										cols: 1
									},
									{
										breakpoint: 760,
										cols: 1
									},
									{
										breakpoint: 480,
										cols: 1
									},
								]}
								mobileBreakpoint={105}
							>
								{
									planes?.length > 0 ? planes.map(plan => (
										<Carousel.Item key={uuid()}>
											<div className="chGuideChannelPlanBox" key={uuid()} data-idplan={plan.fi_plan}>
												<h3 className="h5"><strong>{plan.fc_nombre} {plan.fc_texto_caja}</strong></h3>
												<div className="chGuideChPlanBoxText">
													<div className="chGuideChPBTextInfo">
														<p>{getTxtCaracteristicas(plan.caracteristicas)}</p>
													</div>
													<div className="chGuideChPBTextPrecio">
														<div className="chGuideChPBTextPrecioNumber">
															<span>{plan.fc_etiqueta_periodo}</span>
															<p>
																{<NumericFormat prefix={symbolPrice} thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(plan.fi_precio_plan) ? plan.fi_precio_plan+".00" : plan.fi_precio_plan.toFixed(2)} />}
															</p>
														</div>
														<div className="chGuideChPBTextPrecioBtn">
															{
																plan.fc_texto_contratar ?
																	plan.fc_opcion_contratacion === "URL" ?
																		<div className="cPlanV2Actions">
																			<a className="btn btnPrimario" href={plan.fc_url_contratar} target={plan.fc_target_contratar ? plan.fc_target_contratar : '_self'}>
																				{plan.fc_texto_contratar}
																			</a>
																		</div>
																		:
																		<div className="cPlanV2Actions">
																			<a className="btn btnPrimario" href="#!" onClick={() => setValuesModalSolicitar(plan)} target={'_self'}>
																				{plan.fc_texto_contratar}
																			</a>
																		</div>
																	: null
															}
														</div>
													</div>
												</div>
												{
													dataChannels.length > 0 &&
													<>
														<div className="chGuideChPlanBoxList">
															<p><strong>Otros Canales que incluye este plan:</strong></p>
															<div className="chGuideChPBListCards">
																{
																	_renderChannelBox(dataChannels.slice(0, 12))
																}
															</div>
														</div>
														<div className="chGuideChannelBoxMore">
															{
																dataChannels.length > 12 &&
																<a className="textLink" onClick={() => { onClickChangeChannels(); }} href='#!'>Ver todos los Canales</a>
															}
														</div>
													</>
												}
											</div>
										</Carousel.Item>
									)) : null
								}
							</Carousel>
						</div>
					</div>
				</section>
			}
			<Modal
				ref={modalChannelsRef}
				size={ModalSize.BIG}
			>
				<MChannelsPartModal
					onClose={onClickChangeChannelsClose}
					dataChannels={dataChannels}
					planName={channelName}
					dataCategorias={dataCategorias}
				/>
			</Modal>
			<Modal
				ref={modalRequestRef}
				size={ModalSize.SMALL}
			>
				<MSolicitarPartModal
					modalRef={modalRequestRef}
					openSales={openModalSales}
					title={title}
					name={channelName}
					fc_DESCRIPCION={fc_DESCRIPCION}
					fi_PRECIO_PLAN={fi_PRECIO_PLAN}
					fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
					lstPlanContratacionxPlan={lstPlanContratacionxPlan}
					fi_SERVICIO={fi_SERVICIO}
				/>
			</Modal>
			<Modal
				ref={modalSalesRef}
				size={ModalSize.MEDIUM_3}
			>
				<MSolicitarSalesPartModal
					onClose={() => { closeModalSales(); openModalRequest() }}
				/>
			</Modal>
		</Fragment>
	)
}

export default ChannelGuide
